(function () {
  'use strict';

  angular
    .module('app.password-recovery', [])

    .directive('accountPasswordRecovery', function () {
      return {
        restrict: 'E',
        bindToController: {
          token: '@',
          isTokenValid: '<'
        },
        controllerAs: 'passwordRecoveryCtrl',
        /* @ngInject */
        controller: ["$element", "$scope", "$rootScope", "$location", "HttpService", "AppService", "ModalService", "toastr", function ($element, $scope, $rootScope, $location, HttpService, AppService, ModalService, toastr) {

          var ctrl = this;

          ctrl.$onInit = function () {

            $scope.device = ctrl.device;
            console.log(ctrl.device + 'ctrl device');           
              
            ctrl.formData = {              
              Token: ctrl
                  .token,
              errors: {}
            };


            if (!ctrl.isTokenValid) {
              $element.find('.invalid-token').find('a')
                .attr({
                  'class': 'btn-underline',
                  'href': ''
                })
                .click(function () {
                  ModalService.show(
                    '/Template/Authentication/ModalForgotPassword',
                    null,
                    null,
                    'forgotPasswordModalCtrl'
                  );
                });
            }
          };

          ctrl.submit = function () {
            $rootScope.$broadcast('showPageLoader', true);

            ctrl.formData.errors = {};

            HttpService.post({
              url: '/ChangePassword',
              data: ctrl.formData
            })
            .then(function (response) {
              AppService.getTranslate()
              .then(function (translate) {
                if (response.status === 'OK') {
                  toastr.success('', translate.messages.PasswordModified, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                  $location.path('/').replace();
                } else {
                  _.each(response.errors, function (error, key) {
                    if (key === 'Global') {
                      ctrl.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                    }
                  });
                  $rootScope.$broadcast('showPageLoader', false);
                }
              });
            })
            .catch(function (error) {
              console.error(error);
            });
          };

        }]
      };
    });

})();
